import React, { Component } from 'react'

class FileInput extends Component {
	render () {
		return (
			<label htmlFor='fileinput' className='db ma3 f2 tc dim br2 pv2 white bg-black-70'>
				<input className='dn' type='file' id='fileinput' onChange={(event) => {
					console.log('coucou', event, event.target, event.target.files)
					const f = event.target.files[0]
					if (!f)
						return
					const r = new FileReader()
					r.onload = (e) => {
						const text = e.target.result
						console.log(text)
						window.sigma_inst.killForceAtlas2()
						window.sigma_inst.graph.clear()
						window.parseCSV(text)
					}
					r.readAsText(f)
				}}/>
				Upload
			</label>
		)
	}
}

export default FileInput



// WEBPACK FOOTER //
// ./src/components/FileInput.js